<template>
	<div v-loading="loading">
		<div class="doctorRanking">
			<el-row :gutter="10">
				<el-col :span="5">
					<div class="contentsmlBox cur">
						<div class="bottom white" @click="experClick('total','false','被质控总数')">
							被质控总数 <span class="marl10 rt">{{getDashboradData.SamplingReportCount}}</span>
						</div>
						<div class="top" @click="experClick('thisTime','false')">
							<svg-icon class="titleSvg" icon-class='icon-home-Qualitycontrolbl'></svg-icon>
							<span class="marl10">本次</span>
							<span class="num">{{getDashboradData.LatestSamplingReportCount}}</span>
						</div>
					</div>
				</el-col>
				<el-col :span="5">
					<div class="contentsmlBox cur">
						<div class="bottom white" @click="experClick('total','true','不合格总数')">
							不合格总数 <span class="marl10 rt">{{getDashboradData.UnqualifiedReportCount}}</span>
						</div>
						<div class="top" @click="experClick('thisTime','true')">
							<svg-icon class="titleSvg" icon-class='icon-home-unqualified'></svg-icon>
							<span class="marl10">本次</span>
							<span class="num">{{getDashboradData.LatestUnqualifiedReportCount}}</span>
						</div>
					</div>
				</el-col>
				<el-col :span="5">
					<div class="contentsmlBox cur">
						<div class="bottom white" @click="experClick('total','true','不合格率')">
							不合格率 <span class="marl10 rt">
								{{getDashboradData.UnqualifiedReportRate==null?0:getDashboradData.UnqualifiedReportRate}}
							</span>
						</div>
						<div class="top" @click="experClick('thisTime','true')">
							<svg-icon class="titleSvg" icon-class='icon-home-Unqualifiedrate'></svg-icon>
							<span class="marl10">本次</span>
							<svg-icon v-if="getDashboradData.UnqualifiedReportRate>getDashboradData.LatestUnqualifiedReportRate" class="fz12 marl5" icon-class="icon-home-Down"></svg-icon>
								<svg-icon v-if="getDashboradData.UnqualifiedReportRate<getDashboradData.LatestUnqualifiedReportRate" class="fz12 verB marl5" icon-class="icon-home-up"></svg-icon>
							<span class="num">{{getDashboradData.LatestUnqualifiedReportRate==null?0:getDashboradData.LatestUnqualifiedReportRate}}</span>
						</div>
					</div>
				</el-col>
				<el-col :span="5">
					<div class="contentsmlBox cur">
						<div class="bottom white" @click="experClick('total','false','总平均分')">
							总平均分 <span class="marl10 rt">
								{{getDashboradData.AvgScore==null?0:getDashboradData.AvgScore}}
							</span>
						</div>
						<div class="top" @click="experClick('thisTime','false')">
							<svg-icon class="titleSvg" icon-class='icon-home-average'></svg-icon>
							<span class="marl10">本次</span>
							<svg-icon v-if="getDashboradData.AvgScore>getDashboradData.LatestAvgScore" class="fz12 marl5" icon-class="icon-home-Down"></svg-icon>
								<svg-icon v-if="getDashboradData.AvgScore<getDashboradData.LatestAvgScore" class="fz12 verB marl5" icon-class="icon-home-up"></svg-icon>
							<span class="num">{{getDashboradData.LatestAvgScore==null?0:getDashboradData.LatestAvgScore}}</span>
						</div>
					</div>
				</el-col>
				<el-col :span="5">
					<div class="contentsmlBox cur">
						<div class="bottom white" @click="experClick('total','false','院内总排名')">
							院内总排名 <span class="marl10 rt">
								{{getDashboradData.Rank}}
							</span>
						</div>
						<div class="top" @click="experClick('thisTime','false')">
							<svg-icon class="titleSvg" icon-class='icon-home-ranking'></svg-icon>
							<span class="marl10">本次</span>
							<svg-icon v-if="getDashboradData.Rank<getDashboradData.LatestInRank" class="fz12 marl5" icon-class="icon-home-Down"></svg-icon>
								<svg-icon v-if="getDashboradData.Rank>getDashboradData.LatestInRank" class="fz12 verB marl5" icon-class="icon-home-up"></svg-icon>
							<span class="num">{{getDashboradData.LatestInRank}}</span>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div v-if="getDashboradData.SamplingReportCount != 0">
			<div class="pointsDeducted">
				<el-row :gutter="10">
					<el-col :span="9">
						<div class="contentBigBox">
							<div class="title marb18">
								<svg-icon class="fz18 marr4 svgColor" icon-class="icon-time"></svg-icon>
								本次扣分项情况
							</div>
							<div class="pie">
								<el-table class="qcTable doctor" height="252" @row-click="experClick" :data="getDashboradData.LatestReduceScoreItems">
									<el-table-column align='left' prop="Desc" label="扣分项描述"></el-table-column>
									<el-table-column align='left' width="100" prop="Count" label="出现次数"></el-table-column>
								</el-table>
							</div>
						</div>
					</el-col>
					<el-col :span="15">
						<div class="contentBigBox" ref="pieChart">
							<div class="title">
								<svg-icon class="fz18 marr4 svgColor" icon-class="homePage"></svg-icon>
								累计扣分项情况
							</div>
							<div class="pie" style="width:100%; height:270px;">
								<div id="pointsPie" style="width: 100%;height: 100%;"></div>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="contentBigBox doctorChart" ref="lineChart" id="lineChart" v-loading="chartsLoading">
				<div class="monthlyRanking">
					<div class="doctorChartLTitle">
						<svg-icon class="fz18 marr4 svgColor" icon-class="icon-average"></svg-icon>
						历史平均分
					</div>
					<div class="doctorChartDate rt">
						<el-form ref="form" class="qcFrom homePageSeach">
							<el-form-item class="dateForm" label="创建时间">
								<el-date-picker class="time sliderDataCls" v-model="reportDoctorPar.data" type="daterange" @change="search" size="mini" range-separator="~" value-format="yyyy-MM-dd" format="yyyy-MM-dd" start-placeholder="开始时间" end-placeholder="结束时间">
								</el-date-picker>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="rankingChart" style="width:100%; height:290px">
					<div id="rankingChart" style="width: 100%;height: 100%;"></div>
				</div>
			</div>
		</div>
		<div v-else>
			<nodata-img></nodata-img>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import echarts from 'echarts'
	import nodataImg from '@/components/Common/noDataImg';
	export default {
		data() {
			return {
				startDatePicker: this.beginDate(),
				endDatePicker: this.processDate(),
				pieChart:null,
				myChart:null,
			}
		},
		components:{
			nodataImg
		},
		computed: {
			...Vuex.mapState('doctor', ['chartsLoading','loading','role','samplingTaskGuid','taskListTitle','getReporterReportListArr','reportDoctorPar', 'getDashboradData']),
			...Vuex.mapState('breadcrumb', ['pieColorList','skinPeeler'])
		},
		watch: {
			$route(to, from) {},
			skinPeeler: {
			  handler(newValue, oldValue) {
				 this.getRankingEcharts();
			     this.getReduceScoreItems();
			  },
			  deep: true
			}
		},
		updated() {
			if (this.$route.path == "/home/doctor/homePage") {
				this.getRankingEcharts();
				this.getReduceScoreItems();
			}
		},
		activated() {
			this.clearRow();
			this.setLoading(true);
			this.GetDashborad();
		},
		mounted() {
			if (this.$route.path == "/home/doctor/homePage") {
				//左侧导航收起时右侧图联动
				let _this = this;
			    this.erd.listenTo(document.getElementsByClassName("el-main"), function (element) {
			       if (_this.myChart) {
						let dom = document.getElementById("rankingChart");
						let dompie = document.getElementById("pointsPie");
						if(dom||dompie){
							dom.style.width = _this.$refs.lineChart.offsetWidth-40 + "px";
							dompie.style.width = _this.$refs.pieChart.offsetWidth-40 + "px";
							_this.myChart.resize();
							_this.pieChart.resize();
							_this.getReduceScoreItems();
						}
					}
			    })
		   }
		},
		methods: {
			...Vuex.mapMutations('breadcrumb',['setTootipType','clearRow']),
			...Vuex.mapMutations('doctor', ['doctorDoctorStatus','setChartsLoading','isRole','getDashboradMu','setLoading']),
			...Vuex.mapActions('doctor', ['GetDashborad']),
			search() {
				this.setChartsLoading(true);
				this.reportDoctorPar.enddt = this.reportDoctorPar.data[1];
				this.reportDoctorPar.startdt = this.reportDoctorPar.data[0];
				this.GetDashborad();
			},
			getReduceScoreItems() {
				let dom = document.getElementById('pointsPie');
				this.pieChart = echarts.init(dom);
				let app = {};
				let datas = [];
				let color = [];
				color = this.pieColorList.color2;
				this.getDashboradData.ReduceScoreItems.map(res => {
					datas.push({
						name: res.Desc,
						value: res.Count
					})
				})
				let changeColor = this.skinPeeler.status?'#ffffff':'#333333';
				let option = {
					color: color,
					legend: {
						type: 'scroll',
						icon: 'circle',
						orient: 'vertical',
						align: 'left',
						itemGap: 15,
						left: 20,
						top: 20,
						bottom: 20,
						itemWidth: 10,
						itemHeight: 10,
						data: datas,
						pageIconSize:8,
						pageIconInactiveColor:'#c4c4c4',
						pageIconColor:changeColor,
						pageTextStyle:{
				            color:changeColor
				        },
						textStyle: {
							color: changeColor,
							rich: {
								a: {
									fontSize: 14,
								},
								b: {
									fontSize: 12,
									fontWeight:'bold',
								}
							}
						},
						formatter: function(name) {
							let target;
							let data = option.series[0].data;
				            let total = 0;
				            
							for(let i = 0, l = datas.length; i < l; i++) {
								total += data[i].value;
								if(datas[i].name == name) {
									target = datas[i].value;
								}
							}
							let p = ((target / total) * 100).toFixed(2);
							name = name.length > 10&&document.body.clientWidth<=1440 ? name.substr(0, 10) + '...' : name;
							return '{b|' + p + '% }'+'{a|' + name + '}'
						},
						tooltip: {
							show: true,
						}
					},
					tooltip: {
						trigger: 'item',
						// formatter: '{a} <br/>{b} : {c} ({d}%)'
						formatter: function(name) {
							var newStr = " ";
							var start, end;　　　　
							var name_len = name.name.length;　　　　　　　　　　　　 //每个内容名称的长度
							var max_name = 10;　　　　　　　　　　　　　　　　　　 //每行最多显示的字数
							var new_row = Math.ceil(name_len / max_name);　　　　 // 最多能显示几行，向上取整比如2.1就是3行
							if(name_len > max_name) {　　　　　　　　　　　　　　 //如果长度大于每行最多显示的字数
								for(var i = 0; i < new_row; i++) {　　　　　　　　　　　 //循环次数就是行数　　　　　　　　
									var old = '';　　　　　　　　　　　　　　　　 //每次截取的字符　　　　　　　　
									start = i * max_name;　　　　　　　　　　 //截取的起点
									end = start + max_name;　　　　　　　　　 //截取的终点
									if(i == new_row - 1) {　　　　　　　　　　　　 //最后一行就不换行了
										old = name.name.substring(start);　　　　　　　　
									} else {　　　　　　　　　　
										old = name.name.substring(start, end) + "<br/>";　　　　　　　　
									}　　　　　　　　　　
									newStr += old; //拼接字符串
								}　　　
							} else { //如果小于每行最多显示的字数就返回原来的字符串
								newStr = name.name;　　　
							}　　　
							return name.seriesName + ' <br/>' + newStr + ': '+name.value+' ('+name.percent+'%)';　　
						}
					},
					series: [{
						name: '扣分项',
						type: 'pie',
						center: ['70%', '50%'],
						radius: ["58%","80%"],
						hoverOffset: 10,
						avoidLabelOverlap: false,
						minAngle: 0,//最小角度
						startAngle:180, //起始角度
						label: {
							show:false,
							lineHeight:15,
							align: 'left',
							color: '#fff',
							rich: {
								b: {
									fontWeight:'bold',
									color: '#fff',
								},
							},
							formatter: function(name) {　　　　
								let newStr = " ";
								let start, end;　　　　
								let name_len = name.name.length;　　　　　　　　　　　　 //每个内容名称的长度
								let max_name = 6;　　　　　　　　　　　　　　　　　　 //每行最多显示的字数
								let new_row = Math.ceil(name_len / max_name);　　　　 // 最多能显示几行，向上取整比如2.1就是3行
								if(name_len > max_name) {　　　　　　　　　　　　　　 //如果长度大于每行最多显示的字数
									for(let i = 0; i < new_row; i++) {　　　　　　　　　　　 //循环次数就是行数
										　　　　　　　　
										let old = '';　　　　　　　　　　　　　　　　 //每次截取的字符
										　　　　　　　　
										start = i * max_name;　　　　　　　　　　 //截取的起点
										　　　　　　　　
										end = start + max_name;　　　　　　　　　 //截取的终点
										　　　　　　　　
										if(i == new_row - 1) {　　　　　　　　　　　　 //最后一行就不换行了
											　　　　　　　　　　
											old = name.name.substring(start);　　　　　　　　
										} else {　　　　　　　　　　
											old = name.name.substring(start, end) + "\n";　　　　　　　　
										}　　　　　　　　　　
										newStr += old; //拼接字符串
										　　　　　　
									}　　　
								} else { //如果小于每行最多显示的字数就返回原来的字符串
									newStr = name.name;　　　
								}　　　
								return '{a|' + newStr + '} '+'{b|' + name.percent + '%}';　　
							}
						},
						labelLine: {
							lineStyle: {
								color: '#fff'
							},
						},
						data: datas,

					}]
				};
				this.pieChart.clear();
				this.pieChart.setOption(option, true);
				this.pieChart.resize(); //区域更新
				window.addEventListener("resize", () => {
					this.pieChart.resize();
				});
			},
			getRankingEcharts() {
				let dom = document.getElementById("rankingChart");
				this.myChart = echarts.init(dom);
				//院内排名
				let MyScoresdata = [];
				let value = [];
				let color = ['#248AFD'];
				if(this.getDashboradData.MyScores&&this.getDashboradData.MyScores.length > 0) {
					this.getDashboradData.MyScores.forEach(element => {
						MyScoresdata.push({
							value:element.AvgScore,
							text:element.TaskName
						})
						value.push(element.CreateDt)
					})
				}
				let app = {};
				let option = null;
				let changeColor = this.skinPeeler.status?'#ffffff':'#333333';
				option = {
					title: {
						text: '分数',
						padding: [0, 0, 0, 15],
						textStyle: {
							color: changeColor,
							fontSize: 12,
							fontWeight: 'normal',
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer:{
							type:"none"
						},
						formatter: function(params, ticket, callback) {
						    return `${params[0].data.text}`;
						  },
					},
					grid: {
						left: '2%',
						right: '6%',
						bottom: '4%',
						containLabel: true
					},
					xAxis: {
						name:'批次',
						nameTextStyle: {
							color: changeColor
						},
						data: value,
						boundaryGap: false,
						axisLine: {
							show: true,
						},
						axisLabel: {
							textStyle: {
								color: changeColor,
							},
						},
						splitLine: {
							show: false
						}
					},
					yAxis: {
						type: 'value',
						splitLine: { //网格线
							lineStyle: {
								type: 'dashed', //设置网格线类型 dotted：虚线   solid:实线
								color: changeColor
							},
							show: false //隐藏或显示
						},
						axisLabel: {
							textStyle: {
								color: changeColor
							}
						}
					},
					series: [{
						type: 'line',
						color: color[0],
						symbolSize: 8,
						symbol: 'circle',
						lineStyle: {
							normal: {
								color: color[0]
							}
						},
						data: MyScoresdata,
						itemStyle: {
							normal: {
								color: color[0],
								borderColor: color[0],
							}
						},
						areaStyle: {
							color: ["rgba(36, 138, 253,0.5)"]
						}
					}]
				};
				this.myChart.clear();
				this.myChart.setOption(option, true);
				this.myChart.resize(); //区域更新
				window.addEventListener("resize", () => {
					this.myChart.resize();
				});
			},
			beginDate() {    
				const self = this    
				return {      
					disabledDate(time) {       
						if(self.reportDoctorPar.enddt) {  //如果结束时间不为空，则小于结束时间
							return new Date(self.reportDoctorPar.enddt).getTime() < time.getTime()       
						} else {         
							return time.getTime() > Date.now() //开始时间不选时，结束时间最大值小于等于当天
						}      
					}    
				}   
			},
			processDate() {    
				const  self = this    
				return {      
					disabledDate(time) {       
						if(self.reportDoctorPar.startdt) {  //如果开始时间不为空，则结束时间大于开始时间
							return new Date(self.reportDoctorPar.startdt).getTime() > time.getTime()       
						} else {         
							return time.getTime() > Date.now() //开始时间不选时，结束时间最大值小于等于当天
							       
						}      
					}    
				}
			},
			experClick() {
				let type = arguments[0];
				let arg = arguments[1];
				this.doctorDoctorStatus(50);
				this.setTootipType(false);
				this.clearRow();
				if (type == "total") {
					this.taskListTitle.type = 1;
					this.samplingTaskGuid.id = '';
					this.getReporterReportListArr.isUnqualified = arg;
					this.getReporterReportListArr.scoreItem = '';
					this.taskListTitle.name = arguments[2];
				}else if(type == "thisTime"){
					this.taskListTitle.type = 2;
					this.samplingTaskGuid.id = this.getDashboradData.LatestSamplingTaskGuid;
					this.getReporterReportListArr.isUnqualified = arg;
					this.getReporterReportListArr.scoreItem = '';
					this.taskListTitle.name = this.getDashboradData.LatestTaskName;
				}else{
					this.taskListTitle.type = 2;
					this.samplingTaskGuid.id = this.getDashboradData.LatestSamplingTaskGuid;
					this.getReporterReportListArr.isUnqualified = false;
					this.getReporterReportListArr.scoreItem = type.Desc;
					this.taskListTitle.name = this.getDashboradData.LatestTaskName;
				}
				this.setLoading(true);
				this.taskListTitle.categoryName = null;
				this.isRole('doctor');
				this.$router.push("/home/doctor/doctorTable");
			}
		},


	}
</script>